import { createBatchedQueryOptions } from '../internal/createBatchedQueryOptions';
import { internalAccessCheckTaskRunner } from '../internal/internalAccessChecksTaskRunner';

export const getAccessCheckQuery = createBatchedQueryOptions(internalAccessCheckTaskRunner);
